import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { AdminDemoData } from '@platform/client';
import { AnnouncementTypeEnum } from '@platform/client/schemas';
import { FormsInputDropdown } from '@platform/components';
import { AdminFormModal, ModalStage } from '../../AdminFormModal';

type NewDemoCommunityAnnouncementFormData = {
  type: AnnouncementTypeEnum;
};

export const CreateDemoCommunityAnnouncementModal = (props: { onClose: () => void }) => {
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const [successText, setSuccessText] = useState<string>();
  const { control, handleSubmit, formState } = useForm<NewDemoCommunityAnnouncementFormData>({
    mode: 'onChange',
  });

  const createCommunityAnnouncementMutator = AdminDemoData.useCreateDemoCommunityAnnouncement({
    mutation: {
      onMutate: () => setModalStage('submitting'),
      onError: () => setModalStage('error'),
      onSuccess: (data) => {
        setSuccessText(
          `Announcement #${data.communityAnnouncementId} ("${data.title}") created for ${data.type}s.`,
        );
        setModalStage('success');
      },
    },
  });

  const onSubmit: SubmitHandler<NewDemoCommunityAnnouncementFormData> = (data) => {
    createCommunityAnnouncementMutator.mutate({ data: { type: data.type } });
  };

  return (
    <AdminFormModal
      title='Create Demo Community Announcement'
      onClose={props.onClose}
      modalStage={modalStage}
      successText={successText}
      submitCTA={{
        text: 'Create',
        callback: () => handleSubmit(onSubmit)(),
      }}
    >
      <div className='space-y-2'>
        <p className='text-sm text-gray-600'>
          The community page shows reps an organization announcement and pros a professional one,
          so pick which audience this one is for.
        </p>
        <FormsInputDropdown
          type='default'
          control={control}
          name='type'
          label='Audience'
          placeholder='Select an audience'
          rules={{ required: 'Audience is required' }}
          items={[
            { text: 'Professional', textValue: AnnouncementTypeEnum.professional },
            { text: 'Organization', textValue: AnnouncementTypeEnum.organization },
          ]}
          error={formState.errors.type}
        />
      </div>
    </AdminFormModal>
  );
};
